/* eslint-disable i18next/no-literal-string */
import { useAuth } from '@/hooks/useAuth';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { LoginCallback } from '@okta/okta-react';
import { useEffect } from 'react';

function LoginCallbackPage(props: any) {
  const theme = useTheme();
  const { setIsAccessDenied } = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');

    if (error && error === 'access_denied') {
      setIsAccessDenied(true);
    }
  }, [setIsAccessDenied]);

  return (
    <Box
      data-testid="login-callback-page"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        color="primary"
        data-testid="login-callback-spinner"
      />
      <LoginCallback {...props} data-testid="login-callback-component" />
    </Box>
  );
}

export default LoginCallbackPage;
